<template>
    <div class="component">{{ text }}</div>
</template>

<script>
    export default {
        name: 'GTitle',
        props: ['text']
    }
</script>

<style lang="less" scoped>
    .component {
        padding: 18px 16px;
        font-size: 22px;
        font-weight: 600;
        color: #000000;
        line-height: 31px;
    }
</style>